<template>
  <div class="container-fluid px-0 min-h w-100 text-roboto">
    <!-- ВЕРХНЯЯ ПАНЕЛЬ - ТАБЛИЦЫ И ВЫХОД -->
    <mdb-navbar color="elegant" dark class="top-navbar w-100">
      <mdb-navbar-toggler>
        <!-- ЛЕВАЯ ЧАСТЬ - ТАБЛИЦЫ -->
        <mdb-navbar-nav left class="table-section">
          <mdb-dropdown tag="li" class="nav-item">
            <mdb-dropdown-toggle tag="a" navLink slot="toggle" waves-fixed>
              Таблицы
            </mdb-dropdown-toggle>
            <mdb-dropdown-menu>
              <mdb-dropdown-item @click="openDeliveryTable" active>
                Лист отправки Тест
              </mdb-dropdown-item>
              <mdb-dropdown-item @click="openToolsTable">
                План
              </mdb-dropdown-item>
            </mdb-dropdown-menu>
          </mdb-dropdown>
          <!-- КНОПКИ РЕГУЛИРОВКИ ШРИФТА -->
          <mdb-nav-item>
            <mdb-icon 
              icon="minus" 
              size="lg" 
              @click.native="decreaseFont"
              style="cursor: pointer; margin-right: 5px;"
              title="Уменьшить шрифт на 10%"
            />
            <mdb-icon 
              icon="plus" 
              size="lg" 
              @click.native="increaseFont"
              style="cursor: pointer; margin-right: 5px;"
              title="Увеличить шрифт на 10%"
            />
            <small style="font-size: 12px; white-space: nowrap;">
              {{ fontSize }}%
            </small>
          </mdb-nav-item>
        </mdb-navbar-nav>

        <!-- ПРАВАЯ ЧАСТЬ - ВЫХОД -->
        <mdb-navbar-nav right class="logout-section">
          <mdb-nav-item  
            @click="modal_date = true">{{ today }}</mdb-nav-item>
          <mdb-nav-item @click="printTable" class="print-btn">Печать</mdb-nav-item>
          
          <mdb-nav-item @click="logout">Выход</mdb-nav-item>
        </mdb-navbar-nav>
      </mdb-navbar-toggler>
    </mdb-navbar>

    <!-- ПАНЕЛЬ ФИЛЬТРОВ -->
    <div class="filters-panel">
      <div class="filters-main-container">
        
        <!-- СЕКЦИЯ 1: СПОСОБ ОТПРАВКИ -->
        <div class="filter-section">
          <div class="filter-section-title">Способ отправки:</div>
          <div class="filter-checkboxes">
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="deliveryFilters['Почта']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Почта</span>
              </label>
            </div>

            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="deliveryFilters['СДЭК Санкт-Петербург']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">СДЭК</span>
              </label>
            </div>

            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="deliveryFilters['Достависта Санкт-Петербург']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Достависта СПб</span>
              </label>
            </div>

            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="deliveryFilters['Самовывоз из офиса']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Самовывоз</span>
              </label>
            </div>

            <!-- НОВАЯ КАТЕГОРИЯ: НЕ УКАЗАН -->
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="deliveryFilters['Не указан']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Не указан</span>
              </label>
            </div>
          </div>
        </div>

        <!-- СЕКЦИЯ 2: НАКЛАДНАЯ -->
        <div class="filter-section">
          <div class="filter-section-title">Накладная готова:</div>
          <div class="filter-checkboxes">
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="invoiceFilter.ready"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Да</span>
              </label>
            </div>
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="invoiceFilter.notReady"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Нет</span>
              </label>
            </div>
          </div>
        </div>

        <!-- СЕКЦИЯ 3: СТАТУСЫ -->
        <div class="filter-section">
          <div class="filter-section-title">Статусы:</div>
          <div class="filter-checkboxes">
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="statusFilters['Печать СПб (ты предложил допы и вставил ССЫЛКУ НА МАКЕТЫ????)']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Печать СПб</span>
              </label>
            </div>
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="statusFilters['Прислал на печать']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Прислал на печать</span>
              </label>
            </div>
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="statusFilters['Архив Печати']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Архив Печати</span>
              </label>
            </div>
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="statusFilters['В производстве']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">В производстве</span>
              </label>
            </div>
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="statusFilters['Картина готова без допов']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Без допов</span>
              </label>
            </div>
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="statusFilters['Картина Готова СПБ']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">Готова СПБ</span>
              </label>
            </div>
            <!-- НОВЫЕ СТАТУСЫ -->
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="statusFilters['У Декоратора']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">У Декоратора</span>
              </label>
            </div>
            <div class="filter-item">
              <label class="mb-0 d-flex align-items-center filter-label">
                <input 
                  type="checkbox" 
                  v-model="statusFilters['На Упаковке']"
                  class="mr-2 filter-checkbox"
                > 
                <span class="filter-text">На Упаковке</span>
              </label>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Основная таблица -->
    <div v-if="hasActiveFilters" class="row mx-0 mb-4">
      <!-- Добавляем :style для динамического изменения шрифта -->
      <table class="white mb-3 px-0 text-left w-100 mw-100 min-h" :style="{ fontSize: fontSize + '%' }">
        <tr class="text-center">
          <th class="th_date border-dark border">№</th>
          
          <!-- Почта -->
          <th v-if="showPost" class="border-dark border">
            Почта
          </th>
          <th v-if="showPost" class="border border-dark">Допы</th>

          <!-- СДЭК 1 -->
          <th v-if="showSdek" class="px-2 border border-dark">СДЭК <br />Санкт-Петербург</th>
          <th v-if="showSdek" class="border border-dark">Допы</th>

          <!-- СДЭК 2 -->
          <th v-if="showSdek2" class="px-2 border border-dark">
            СДЭК <br />Санкт-Петербург
          </th>
          <th v-if="showSdek2" class="border-dark border">Допы</th>

          <!-- Самовывоз из офиса -->
          <th v-if="showSamovuvozOffice" class="border-dark border">
            Самовывоз <br />из офиса
          </th>
          <th v-if="showSamovuvozOffice" class="border-dark border">
            Допы
          </th>

          <!-- Достависта СПб -->
          <th v-if="showDostavistaSpb" class="border-dark border">
            Достависта Санкт-Петербург
          </th>
          <th v-if="showDostavistaSpb" class="border-dark border">
            Допы
          </th>

          <!-- НЕ УКАЗАН -->
          <th v-if="showUnknown" class="border-dark border">
            Не указан
          </th>
          <th v-if="showUnknown" class="border-dark border">
            Допы
          </th>
        </tr>

        <!-- tbody с динамическим шрифтом -->
        <tbody class="border border-dark rounded-bottom" :style="{ fontSize: fontSize + '%' }">
          <tr
            v-for="(row, index) in tableRows"
            :key="index"
            class="trT text-table border border-dark"
          >
            <td class="text-left td_index border border-dark">
              {{ index + 1 }}
            </td>

            <!-- Почта -->
            <td v-if="showPost" class="border border-dark">
              {{ row.post.id }}
            </td>
            <td v-if="showPost" class="text-left" v-html="row.post.basket"></td>

            <!-- СДЭК 1 -->
            <td v-if="showSdek" class="border border-dark">
              {{ row.sdek.id }}
            </td>
            <td v-if="showSdek" class="border border-dark text-left" v-html="row.sdek.basket"></td>

            <!-- СДЭК 2 -->
            <td v-if="showSdek2" class="border border-dark">
              {{ row.sdek2.id }}
            </td>
            <td v-if="showSdek2" class="border border-dark text-left" v-html="row.sdek2.basket"></td>

            <!-- Самовывоз офис -->
            <td v-if="showSamovuvozOffice" class="border border-dark">
              {{ row.samovuvozOffice.id }}
            </td>
            <td v-if="showSamovuvozOffice" class="border border-dark text-left" 
                v-html="row.samovuvozOffice.basket"></td>

            <!-- Достависта СПб -->
            <td v-if="showDostavistaSpb" class="border border-dark">
              {{ row.dostavistaSpb.id }}
            </td>
            <td v-if="showDostavistaSpb" class="border border-dark text-left" 
                v-html="row.dostavistaSpb.basket"></td>

            <!-- Не указан -->
            <td v-if="showUnknown" class="border border-dark">
              {{ row.unknown.id }}
            </td>
            <td v-if="showUnknown" class="border border-dark text-left" 
                v-html="row.unknown.basket"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Сообщение когда нет активных фильтров -->
    <div v-else class="row mx-0 mb-4 text-center py-5">
      <div class="col-12">
        <h4>Нет активных фильтров</h4>
        <p>Выберите хотя бы один фильтр доставки для отображения таблицы</p>
      </div>
    </div>

    <!-- Модальное окно даты -->
    <mdb-modal :show="modal_date" @close="modal_date = false" class="modalmodal">
      <mdb-modal-header>
        <mdb-modal-title>Дата отправки</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="my-3 text-center">
        <div class="row justify-content-around">
          <input
            v-model="datef"
            class="col-5 mx-1"
            type="date"
            min="2020-11-01"
          />
          <input
            v-model="datet"
            class="col-5 mx-1"
            type="date"
            min="2020-11-01"
          />
        </div>
      </mdb-modal-body>
    </mdb-modal>

    <!-- Статистика внизу -->
    <div v-if="hasActiveFilters" class="row fixed-bottom mx-0 w-100 animated fadeInUp">
      <div class="white justify-content-start pt-2 sumClA pb-2 w-100">
        <div class="col">
          <span class="pl-2">Заказов: {{ orders_Sum }}</span>
          <span class="pl-3"> Картин: {{ goods_Sum }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AUTH_LOGOUT } from "@/store/actions/auth";
import { bus } from "@/main";
import Vue from "vue";
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbIcon,
  mdbDropdown,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbDropdownItem,
  mdbFormInline,
  mdbInput,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbTooltip,
} from "mdbvue";

import basketJSON from "@/components/basket.json";

export default {
  props: ["orders"],
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbIcon,
    mdbDropdown,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbDropdownItem,
    mdbFormInline,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbTooltip,
  },
  data() {
    return {
      fontSize: 100,
      
      isPrinting: false,
      manufacture123435: false,
      today: new Date().toLocaleDateString(),

      deliveryFilters: {
        "Почта": true,
        "СДЭК Санкт-Петербург": true,
        "Самовывоз из офиса": true,
        "Достависта Санкт-Петербург": true,
        "Не указан": true
      },

      invoiceFilter: {
        ready: true,
        notReady: true
      },

      statusFilters: {
        "Печать СПб (ты предложил допы и вставил ССЫЛКУ НА МАКЕТЫ????)": true,
        "Прислал на печать": true,
        "Архив Печати": true,
        "В производстве": true,
        "Картина готова без допов": true,
        "Картина Готова СПБ": true,
        // НОВЫЕ СТАТУСЫ
        "У Декоратора": true,
        "На Упаковке": true
      },

      orders_Sum: 0,
      goods_Sum: 0,
      datef: null,
      datet: null,

      show: false,
      modal_date: false,
      
      SamovuvozOfficeH: true,
      ZaberiMenyaH: true,
      DostavistaSpbH: true,
      DostavistaMskH: true,
      SamovuvozMskH: true,
      test2: false,

      tableColumns: {
        post: [],
        sdek: [],
        sdek2: [],
        samovuvozOffice: [],
        dostavistaSpb: [],
        unknown: []
      },
      
      isDateManuallySelected: false,
      sdekOrders: []
    };
  },
  computed: {
    selectedStatuses() {
      return Object.keys(this.statusFilters).filter(status => this.statusFilters[status]);
    },

    hasActiveFilters() {
      return Object.values(this.deliveryFilters).some(isActive => isActive);
    },

    showPost() {
      return this.deliveryFilters['Почта'] && this.tableColumns.post.length > 0;
    },
    showSdek() {
      return this.deliveryFilters['СДЭК Санкт-Петербург'] && this.sdekOrders.length > 0;
    },
    showSdek2() {
      return this.deliveryFilters['СДЭК Санкт-Петербург'] && this.sdekOrders.length > 0;
    },
    showSamovuvozOffice() {
      return this.deliveryFilters['Самовывоз из офиса'] && this.tableColumns.samovuvozOffice.length > 0;
    },
    showDostavistaSpb() {
      return this.deliveryFilters['Достависта Санкт-Петербург'] && this.tableColumns.dostavistaSpb.length > 0;
    },
    showUnknown() {
      return this.deliveryFilters['Не указан'] && this.tableColumns.unknown.length > 0;
    },

    selectedOrders() {
      // ИСПРАВЛЕНИЕ: защита от отсутствия orderStatus
      let filteredByStatus = this.orders.filter((item) =>
        item.orderStatus && this.selectedStatuses.includes(item.orderStatus.name)
      );
      
      if (!this.isDateManuallySelected || !this.datef || !this.datet) {
        return filteredByStatus;
      }
      
      let dateF = new Date(this.datef);
      let dateT = new Date(this.datet);

      return filteredByStatus.filter((item) => {
        // ИСПРАВЛЕНИЕ: защита от отсутствия customFields
        for (let i = 0, l = (item.customFields || []).length; i < l; i += 1) {
          const field = item.customFields[i];

          if (field.fieldId === 88) {
            let dateShipStr = field.value;
            if (!dateShipStr) return false;
            
            let dateShipDMY = dateShipStr.split(".");
            let dateShipDate = new Date(
              dateShipDMY[2],
              dateShipDMY[1] - 1,
              dateShipDMY[0]
            );
            return (
              dateShipDate.getTime() >= dateF.getTime() &&
              dateShipDate.getTime() <= dateT.getTime()
            );
          }
        }
        return false;
      });
    },

    tableRows() {
      this.orders_Sum = 0;
      this.goods_Sum = 0;
      
      const filteredOrders = this.getFilteredOrders();
      this.orders_Sum = filteredOrders.length;

      const columns = this.distributeOrdersToColumns(filteredOrders);
      
      this.tableColumns = columns;
      
      return this.buildTableRows(columns);
    }
  },
  methods: {
    increaseFont() {
      if (this.fontSize < 200) {
        this.fontSize += 10;
        this.saveFontSizeToLocalStorage();
      }
    },
    
    decreaseFont() {
      if (this.fontSize > 50) {
        this.fontSize -= 10;
        this.saveFontSizeToLocalStorage();
      }
    },
    
    saveFontSizeToLocalStorage() {
      localStorage.setItem('tableFontSize', this.fontSize.toString());
    },
    
    loadFontSizeFromLocalStorage() {
      const savedSize = localStorage.getItem('tableFontSize');
      if (savedSize) {
        this.fontSize = parseInt(savedSize, 10);
      }
    },

    getFilteredOrders() {
      return this.selectedOrders.filter(order => {
        const deliveryType = this.getOrderDeliveryType(order);
        if (!this.deliveryFilters[deliveryType]) {
          return false;
        }

        const invoiceStatus = this.getOrderInvoiceStatus(order);
        if (invoiceStatus === 'ready' && !this.invoiceFilter.ready) {
          return false;
        }
        if (invoiceStatus === 'notReady' && !this.invoiceFilter.notReady) {
          return false;
        }

        return true;
      });
    },

    getOrderDeliveryType(order) {
      // ИСПРАВЛЕНИЕ: || [] защищает от null/undefined customFields
      for (let field of (order.customFields || [])) {
        if (field.fieldId === 87) {
          const value = field.valueAsText;
          return value && value.trim() !== '' ? value : 'Не указан';
        }
      }
      return 'Не указан';
    },

    getOrderInvoiceStatus(order) {
      // ИСПРАВЛЕНИЕ: || [] защищает от null/undefined customFields
      for (let field of (order.customFields || [])) {
        if (field.fieldId === 4819) {
          if (typeof field.value === 'boolean') {
            return field.value ? 'ready' : 'notReady';
          }
          if (typeof field.value === 'string') {
            if (field.value.toLowerCase() === 'да' || field.value.toLowerCase() === 'true') {
              return 'ready';
            } else {
              return 'notReady';
            }
          }
          if (typeof field.value === 'number') {
            return field.value === 1 ? 'ready' : 'notReady';
          }
        }
      }
      return 'notReady';
    },

    distributeOrdersToColumns(orders) {
      const columns = {
        post: [],
        sdek: [],
        sdek2: [],
        samovuvozOffice: [],
        dostavistaSpb: [],
        unknown: []
      };

      const sdekOrdersTemp = [];
      
      orders.forEach(order => {
        const formattedOrder = this.formatOrder(order);
        const deliveryType = this.getOrderDeliveryType(order);
        
        switch(deliveryType) {
          case 'Почта':
            columns.post.push(formattedOrder);
            break;
          case 'СДЭК Санкт-Петербург':
            sdekOrdersTemp.push(formattedOrder);
            break;
          case 'Самовывоз из офиса':
            columns.samovuvozOffice.push(formattedOrder);
            break;
          case 'Достависта Санкт-Петербург':
            columns.dostavistaSpb.push(formattedOrder);
            break;
          case 'Не указан':
            columns.unknown.push(formattedOrder);
            break;
        }
      });

      this.sdekOrders = sdekOrdersTemp;

      if (sdekOrdersTemp.length > 0) {
        const totalSdek = sdekOrdersTemp.length;
        const firstTableCount = Math.ceil(totalSdek / 2);
        
        columns.sdek = sdekOrdersTemp.slice(0, firstTableCount);
        columns.sdek2 = sdekOrdersTemp.slice(firstTableCount);
        
        if (columns.sdek2.length < columns.sdek.length) {
          const diff = columns.sdek.length - columns.sdek2.length;
          const emptyCell = { id: '', basket: '' };
          for (let i = 0; i < diff; i++) {
            columns.sdek2.push(emptyCell);
          }
        }
      }

      return columns;
    },

    formatOrder(order) {
      let urgent = "";
      let oplata = "";
      let foto = "";
      let readySpb = "";
      let itemQuantity = 0;
      const basket = [];
      
      const shortItems = [];
      const otherItems = [];

      if (order.orderStatus && order.orderStatus.name === "Картина Готова СПБ") {
        readySpb = "✓";
      }

      // ИСПРАВЛЕНИЕ: || [] защищает от null/undefined goodsPositions
      for (let goodsItem of (order.goodsPositions || [])) {
        const posSum = goodsItem.price * goodsItem.quantity;
        let itemPoint = String(goodsItem.goods.marking);

        let goods_goods = basketJSON.basket.goods;
        for (let goodsGOD of goods_goods) {
          if (goodsGOD.goods_article === itemPoint) {
            itemQuantity += goodsItem.quantity;
            this.goods_Sum += goodsItem.quantity;
            break;
          }
        }

        if (itemPoint === "C2Ч") {
          continue;
        }

        let isShortItem = false;
        let shortName = '';
        
        if (itemPoint.indexOf("Рама") !== -1 ||
            itemPoint.indexOf("Гель") !== -1 ||
            itemPoint.indexOf("упак") !== -1 ||
            itemPoint.indexOf("Упак") !== -1 ||
            itemPoint.indexOf("Новогодняя") !== -1 ||
            itemPoint.indexOf("УП") !== -1 ||
            itemPoint.indexOf("Цветы") !== -1 ||
            itemPoint.indexOf("лак") !== -1 ||
            itemPoint.indexOf("Поталь") !== -1) {
          
          isShortItem = true;
          
          if (itemPoint === "002 Рама(золото)") shortName = "Р(G)";
          else if (itemPoint === "Рама") shortName = "Р";
          else if (itemPoint === "001 Рама(серебро)") shortName = "Р($)";
          else if (itemPoint === "003 Рама(белая)") shortName = "Р(W)";
          else if (itemPoint === "Дед Мороз 3 упаковка") shortName = "уп дед3";
          else if (itemPoint === "УП именная") shortName = "уп им";
          else if (itemPoint === "УП Бабочки") shortName = "уп баб";
          else if (itemPoint === "Упаковка Цветы") shortName = "уп цветы";
          else if (itemPoint === "Новогодняя  Дед Мороз 2") shortName = "уп дед2";
          else if (itemPoint === "Упаковка в подарок") shortName = "уп в подарок";
          else if (itemPoint === "Гель") shortName = "Г";
          else if (itemPoint === "лак" || itemPoint === "лак за 0") shortName = "Л";
          else if (itemPoint === "004 Рама(кремовая)") shortName = "Р(Cr)";
          else shortName = itemPoint;
          
          shortItems.push(`${shortName}&nbsp;-&nbsp;${goodsItem.quantity}`);
        } else {
          otherItems.push(`${itemPoint}&nbsp;-&nbsp;${goodsItem.quantity}`);
        }
      }

      basket.push(...shortItems, ...otherItems);

      if (
        order.internalComments.indexOf("сроч") !== -1 ||
        order.internalComments.indexOf(" СРОЧ ") !== -1 ||
        order.internalComments.indexOf("срочный") !== -1 ||
        order.internalComments.indexOf(" СРОЧНЫЙ ") !== -1
      ) {
        urgent = "!";
      }

      if (
        order.internalComments.indexOf("100%") !== -1 ||
        order.internalComments.indexOf(" Сто ") !== -1 ||
        order.internalComments.indexOf("СТО") !== -1 ||
        order.internalComments.indexOf(" 100 ") !== -1 ||
        order.internalComments.indexOf(" сто ") !== -1
      ) {
        oplata = "%";
      }

      if (
        order.internalComments.indexOf("фот") !== -1 ||
        order.internalComments.indexOf("Фот") !== -1 ||
        order.internalComments.indexOf("ФОТО") !== -1
      ) {
        foto = "Ф";
      }

      return {
        id: `${urgent} ${oplata} ${foto} ${readySpb} ${order.internalNumber} | ${itemQuantity}`,
        basket: basket.join(", ")
      };
    },

    buildTableRows(columns) {
      const rowCounts = [
        columns.post.length,
        columns.sdek.length,
        columns.sdek2.length,
        columns.samovuvozOffice.length,
        columns.dostavistaSpb.length,
        columns.unknown.length,
        60
      ];
      
      const maxRows = Math.max(...rowCounts);

      const rows = [];
      const emptyCell = { id: '', basket: '' };

      for (let i = 0; i < maxRows; i++) {
        rows.push({
          post: columns.post[i] || emptyCell,
          sdek: columns.sdek[i] || emptyCell,
          sdek2: columns.sdek2[i] || emptyCell,
          samovuvozOffice: columns.samovuvozOffice[i] || emptyCell,
          dostavistaSpb: columns.dostavistaSpb[i] || emptyCell,
          unknown: columns.unknown[i] || emptyCell
        });
      }

      return rows;
    },

    printTable() {
      window.print();
    },

    openDateModal() {
      this.modal_date = true;
    },

    closeDateModal() {
      if (this.datef && this.datet) {
        this.isDateManuallySelected = true;
        if (this.datet) {
          this.today = new Date(this.datet).toLocaleDateString();
        }
      }
      this.modal_date = false;
    },

    openDeliveryTable() {
      bus.$emit("deliveryTableB", true);
    },
    openToolsTable() {
      bus.$emit("toolsTableB", true);
    },
    async logout() {
      await this.$store.dispatch(AUTH_LOGOUT);
      this.$router.push("/");
    },
  },

  mounted() {
    this.loadFontSizeFromLocalStorage();
  },

  watch: {
    datet: function (newVal) {
      if (newVal) {
        this.today = new Date(newVal).toLocaleDateString();
        if (this.datef) {
          this.isDateManuallySelected = true;
        }
      }
    },
    datef: function (newVal) {
      if (newVal && this.datet) {
        this.isDateManuallySelected = true;
      }
    }
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}

/* ВЕРХНЯЯ ПАНЕЛЬ - ТАБЛИЦЫ И ВЫХОД */
.top-navbar {
  min-height: 60px !important;
  padding: 8px 0 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.table-section {
  margin-right: 30px;
}

.logout-section {
  margin-left: 30px;
}

/* Стили для кнопок регулировки шрифта */
.mdb-nav-item {
  display: flex;
  align-items: center;
  margin-right: 10px;
}

/* ПАНЕЛЬ ФИЛЬТРОВ */
.filters-panel {
  background-color: #2e2e2e;
  padding: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Основной контейнер фильтров */
.filters-main-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Секция фильтра */
.filter-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 15px;
  min-width: 200px;
}

/* Заголовок секции */
.filter-section-title {
  color: #ff9800;
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 8px;
  white-space: nowrap;
  border-bottom: 1px solid rgba(255, 152, 0, 0.3);
  padding-bottom: 2px;
  width: 100%;
}

/* Контейнер чекбоксов */
.filter-checkboxes {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

/* Элементы фильтра */
.filter-item {
  margin: 0 !important;
  white-space: nowrap;
}

.filter-label {
  color: white !important;
  font-size: 0.85rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  width: 100%;
}

.filter-label:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.filter-checkbox {
  margin: 0;
  transform: scale(0.9);
  accent-color: #ff9800;
}

.filter-text {
  margin-left: 6px;
  white-space: nowrap;
}

/* Адаптивность */
@media (max-width: 1200px) {
  .filters-main-container {
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  
  .filter-section {
    min-width: 180px;
    margin-bottom: 15px;
  }
}

@media (max-width: 768px) {
  .filters-main-container {
    flex-direction: column;
  }
  
  .filter-section {
    width: 100%;
    margin: 0 0 15px 0;
  }
}

/* СТИЛИ ДЛЯ ПЕЧАТИ */
@media print {
  .top-navbar,
  .filters-panel,
  .mdb-nav-item:has(.mdb-icon) {
    display: none !important;
  }

  .fixed-bottom {
    display: none !important;
  }

  .container-fluid {
    padding: 0 !important;
    margin: 0 !important;
  }

  .row {
    margin: 0 !important;
  }

  table {
    width: 100% !important;
    border-collapse: collapse !important;
  }

  .white {
    background: white !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .border-dark {
    border-color: #000 !important;
  }

  body, .min-h {
    background: white !important;
    color: black !important;
  }
}

/* Стили для улучшения отображения при изменении шрифта */
.trT {
  transition: font-size 0.2s ease;
}

.td_index {
  white-space: nowrap;
  transition: font-size 0.2s ease;
}
</style>